import React from 'react';
import { MapPin, Phone, Instagram, Facebook, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark text-brand-light pt-20 pb-10 border-t border-brand-gold/20" data-id="element-122">
      <div className="container mx-auto px-6 md:px-12" data-id="element-123">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-124">
          {/* Brand Col */}
          <div className="flex flex-col items-center md:items-start" data-id="element-125">
            <img src="https://cdn.magicpatterns.com/uploads/5ehSxxLNge9mVEnk9GFcym/Glitzz_by_Shazz_Logo.png" alt="Glitzz by Shazz Logo" className="h-20 w-auto object-contain mb-6 invert brightness-0" data-id="element-126" />
            <p className="text-brand-light/70 text-center md:text-left font-light max-w-xs" data-id="element-127">
              Elevating your natural beauty with signature styles, flawless
              extensions, and unparalleled artistry.
            </p>
          </div>

          {/* Contact Col */}
          <div className="flex flex-col items-center md:items-start" data-id="element-128">
            <h4 className="text-brand-gold font-serif text-xl mb-6" data-id="element-129">
              Contact & Location
            </h4>
            <ul className="space-y-4 text-brand-light/80 font-light" data-id="element-130">
              <li data-id="element-131">
                <a href="https://maps.google.com/?q=3501+Inverrary+Blvd,+Lauderhill,+FL+33319" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 hover:text-brand-gold transition-colors" data-id="element-132">
                  <MapPin className="w-5 h-5 shrink-0 mt-0.5 text-brand-purple" data-id="element-133" />
                  <span data-id="element-134">
                    3501 Inverrary Blvd
                    <br data-id="element-135" />
                    Lauderhill, FL 33319
                  </span>
                </a>
              </li>
              <li data-id="element-136">
                <a href="tel:+16463974299" className="flex items-center gap-3 hover:text-brand-gold transition-colors" data-id="element-137">
                  <Phone className="w-5 h-5 shrink-0 text-brand-purple" data-id="element-138" />
                  <span data-id="element-139">+1 (646) 397-4299</span>
                </a>
              </li>
              <li data-id="element-140">
                <a href="mailto:hello@glitzzbyshazz.com" className="flex items-center gap-3 hover:text-brand-gold transition-colors" data-id="element-141">
                  <Mail className="w-5 h-5 shrink-0 text-brand-purple" data-id="element-142" />
                  <span data-id="element-143">hello@glitzzbyshazz.com</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Social Col */}
          <div className="flex flex-col items-center md:items-start" data-id="element-144">
            <h4 className="text-brand-gold font-serif text-xl mb-6" data-id="element-145">
              Follow the Glamour
            </h4>
            <div className="flex gap-4" data-id="element-146">
              <a href="https://www.instagram.com/shazzunlimited/" target="_blank" rel="noopener noreferrer" aria-label="Follow Glitzz by Shazz on Instagram" className="w-10 h-10 bg-brand-purple/20 flex items-center justify-center hover:bg-brand-purple hover:text-white transition-colors" data-id="element-147">
                <Instagram className="w-5 h-5" data-id="element-148" />
              </a>
              <a href="https://www.facebook.com/groups/58819640960/" target="_blank" rel="noopener noreferrer" aria-label="Join Glitzz by Shazz on Facebook" className="w-10 h-10 bg-brand-purple/20 flex items-center justify-center hover:bg-brand-purple hover:text-white transition-colors" data-id="element-149">
                <Facebook className="w-5 h-5" data-id="element-150" />
              </a>
            </div>
            <div className="mt-8" data-id="element-151">
              <p className="text-sm text-brand-light/50 uppercase tracking-widest mb-2" data-id="element-152">
                Hours
              </p>
              <p className="text-brand-light/80 font-light" data-id="element-153">
                By Appointment Only
              </p>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-brand-light/50 font-light" data-id="element-154">
          <p data-id="element-155">
            &copy; {new Date().getFullYear()} Glitzz by Shazz. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-156">
            <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-157">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-158">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}